exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-tab[data-v-33f62c96]{padding:0 !important;color:var(--grey-pipe) !important;touch-action:none}", ""]);

